module.exports = __webpack_public_path__ + "img/orange-ball-2.5a4ea6d9.svg";